import L from "leaflet";
import React from "react";
import { GeoJSON, LayerGroup, LayersControl } from "react-leaflet";
import { ECAGeoJson, HRAGeoJson, JWCGeoJson } from "../containers/User/Calculator/DistanceMatrix/geoConstant";
import { repeatOnWorldCopies, WorldCopies } from "./worldCopies";

// Regulatory zone overlays (ECA / HRA / JWC), repeated on every world copy, with hover tooltips.

export const ZONES = [
  { label: "ECA zones", data: ECAGeoJson, color: "#10b981", checked: true, name: (f) => `${f.properties.name} ECA`, rule: "ECA · 0.1% S" },
  { label: "HRA zones", data: HRAGeoJson, color: "#ef4444", name: (f) => f.properties.name, rule: "High Risk Area" },
  { label: "JWC zones", data: JWCGeoJson, color: "#f59e0b", name: () => "JWC Listed Area", rule: "War risk premium" },
];

const zoneOptions = (zone, offset) => ({
  style: { color: zone.color, weight: 1.5, fillOpacity: 0.12 },
  coordsToLatLng: ([lng, lat]) => L.latLng(lat, lng + offset),
  onEachFeature: (f, layer) => layer.bindTooltip(`<b>${zone.name(f)}</b><br/>${zone.rule}`, { sticky: true }),
});

// Plain Leaflet: { label: layerGroup } for L.control.layers overlays; checked zones are added to the map
export const zoneOverlays = (map) =>
  Object.fromEntries(
    ZONES.map((zone) => {
      const group = L.layerGroup();
      repeatOnWorldCopies(map, [-180, 180], (offset) => group.addLayer(L.geoJSON(zone.data, zoneOptions(zone, offset))));
      if (zone.checked) group.addTo(map);
      return [zone.label, group];
    })
  );

// react-leaflet: one zone on every world copy
export const ZoneLayer = ({ zone }) => (
  <WorldCopies lngs={[-180, 180]}>{(offset) => <GeoJSON data={zone.data} {...zoneOptions(zone, offset)} />}</WorldCopies>
);

// react-leaflet: place inside <LayersControl>
export const ZoneOverlays = () =>
  ZONES.map((zone) => (
    <LayersControl.Overlay key={zone.label} checked={!!zone.checked} name={zone.label}>
      <LayerGroup>
        <ZoneLayer zone={zone} />
      </LayerGroup>
    </LayersControl.Overlay>
  ));
